export const MAGAZINE = "/magazines";
export const NEWS = "/news";
export const NEWS_CATEGORY = "/news/category";

export const BASE_URL = "/assets/images";
export const BASE_FILE_URL = "/assets/files";
export const GET_PRIVATE_URL = "/assets/files";
export const FILTER_OPTION_URL = "/magazines/filterOption";
export const MAGAZINE_FAVORITE_URL = "/magazines/favorite";
export const MAGAZINE_LIKE_URL = "/magazines/like";
export const OTP_URL = "/auth/request-otp";
export const LOGION_URL = "/auth/login";
export const NEW_TOKEN_URL = "/auth/new-token";
export const BASIC_INFO_URL = "/member/profile/basic-info";
export const PROFILE_INFO_URL = "/member/profile/public";
export const DELETE_ACCOUNT_URL = "/member/profile/request-deletion";
export const UPLOAD_AVATAR_URL = "/member/profile/upload";
export const UPDATE_PHONE_URL = "/member/profile/phoneNumber";
export const FASHION_URL = "/fashions"
export const GALLERY_URL = "/gallery"
export const TECHNICAL_CATEGORY_URL = "/technicals/category"
export const TECHNICAL_URL = "/technicals"
export const COURSES_CATEGORY_URL = "/courses/categories"
export const TEACHER_URL = "/teachers"
export const COURSES_URL = "/courses"
export const COURSE_TEACHER_URL = "/courses/teacher"
export const COURSE_FAVORITE_URL = "/courses/favorite"
export const COURSE_FAVORITES_URL = "/courses/favorites"
export const COURSE_PURCHASES_URL = "/courses/purchases"
export const PRODUCT_URL = "/products";
export const PRODUCT_CATEGORY_URL = "/products/categories";
export const PRODUCT_KNOWLEDGE_URL = "/products-knowledge";

export const SUBSCRIPTIONS_PLAN_URL = "/subscriptions/plan";
export const SUBSCRIPTIONS_TRIAL_URL = "/subscriptions/trial";
export const SUBSCRIPTIONS_PRO_URL = "/subscriptions/pro";
export const SUBSCRIPTIONS_VIP_URL = "/subscriptions/super";
export const SUBSCRIPTIONS_HISTORY_URL = "/subscriptions/history";
export const SUBSCRIPTIONS_PAYMENT_URL = "/subscriptions/payment";
export const COURSE_PRO_PURCHASES_URL = "/courses/purchase";
export const COURSE_PAYMENT_URL = "/courses/payment";
export const RECEIVERS_URL = "/receivers";
export const CART_URL = "/carts";
export const CART_COUNT_URL = "/carts/count";
export const ORDERS_URL = "/orders";
export const EVENTS_URL = "/events";
export const EVENTS_SUBMISSION_URL = "/events/submition";
